'use client';

import { useState } from 'react';
import { Menu, X, ShoppingCart, User } from 'lucide-react';
import Link from 'next/link';
import { useAuth } from '@/app/context/AuthContext';
import CartIcon from './CartIcon';

export default function Navbar() {
  const { user, loading: authLoading } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavClick = (sectionId) => {
    setIsMenuOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navLinks = [
    { label: 'Produits', sectionId: 'best-products' },
    { label: 'Avantages', sectionId: 'advantages' },
    { label: 'Services', sectionId: 'services' },
    { label: 'Découvrir', sectionId: 'discover-more' },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">

          <Link href="/" className="flex items-center gap-2 group min-h-11">
            <span className="font-bold text-lg sm:text-xl text-gray-900 group-hover:text-[#23994F] transition-colors">
              VERPHONE
            </span>
          </Link>


          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.sectionId}
                onClick={() => handleNavClick(link.sectionId)}
                className="text-gray-700 font-semibold hover:text-[#23994F] transition-colors relative group"
              >
                {link.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#23994F] group-hover:w-full transition-all duration-300"></span>
              </button>
            ))}
            <a
              href="/about"
              className="text-gray-700 font-semibold hover:text-[#23994F] transition-colors relative group"
            >
              À Propos
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#23994F] group-hover:w-full transition-all duration-300"></span>
            </a>
          </div>


          <div className="flex items-center gap-3">
            {!authLoading && (
              <>
                {user ? (
                  <>

                    <div className="hidden sm:flex">
                      <CartIcon />
                    </div>


                    <Link
                      href="/account"
                      className="hidden sm:flex items-center gap-2 px-4 py-2 min-h-11 bg-gray-100 text-gray-700 font-semibold text-sm rounded-lg hover:bg-gray-200 transition-all duration-300"
                    >
                      <User size={18} />
                      <span>Mon compte</span>
                    </Link>
                  </>
                ) : (
                  <Link
                    href="/login"
                    className="hidden sm:block px-4 sm:px-5 py-2 min-h-11 bg-[#23994F] text-white font-semibold text-sm sm:text-base rounded-lg hover:bg-[#1a7840] transition-all duration-300 hover:shadow-lg"
                  >
                    Se connecter
                  </Link>
                )}
              </>
            )}


            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 text-gray-700 hover:text-[#23994F] transition-colors"
              aria-label={isMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
              aria-expanded={isMenuOpen}
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>


        {isMenuOpen && (
          <div className="md:hidden pb-4 sm:pb-6 border-t border-gray-200">
            <div className="flex flex-col gap-2 pt-4">
              {navLinks.map((link) => (
                <button
                  key={link.sectionId}
                  onClick={() => handleNavClick(link.sectionId)}
                  className="text-left text-gray-700 font-semibold hover:text-[#23994F] transition-colors py-3 px-4 min-h-12 rounded-lg hover:bg-gray-50 text-base"
                >
                  {link.label}
                </button>
              ))}
              <a
                href="/about"
                className="text-left text-gray-700 font-semibold hover:text-[#23994F] transition-colors py-3 px-4 min-h-12 rounded-lg hover:bg-gray-50 text-base flex items-center"
              >
                À Propos
              </a>
              {user && (
                <div className="px-4 py-2">
                  <CartIcon />
                </div>
              )}
              {!authLoading && (
                <>
                  {user ? (
                    <Link
                      href="/account"
                      className="w-full px-4 py-3 min-h-12 mt-2 bg-gray-100 text-gray-700 font-semibold text-base rounded-lg hover:bg-gray-200 transition-all flex items-center justify-center gap-2"
                    >
                      <User size={18} />
                      Mon compte
                    </Link>
                  ) : (
                    <Link
                      href="/login"
                      className="w-full px-4 py-3 min-h-12 mt-2 bg-[#23994F] text-white font-semibold text-base rounded-lg hover:bg-[#1a7840] transition-all"
                    >
                      Se connecter
                    </Link>
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
